import { HttpErrorResponse } from '@angular/common/http';

export const CONNECTION_ERROR_MESSAGE = 'We couldn\'t reach TIDY. Check your internet connection and try again.';

// A request that got no usable answer: the network dropped it, or something between the app and the
// API (the load balancer's own 502/503, an ad blocker) answered without CORS headers, so the browser
// reports status 0. HttpClientCustom rejects with the bare XHR ProgressEvent in that case, so the
// status is gone and the event's shape is all there is to go on.
export function isConnectionError(error: any): boolean {
  if (!error) {
    return false;
  }
  if (error instanceof HttpErrorResponse) {
    return error.status === 0;
  }
  if (error.name === 'TimeoutError') {
    return true;
  }
  if (typeof ProgressEvent !== 'undefined' && error instanceof ProgressEvent) {
    return true;
  }
  return error.status === 0;
}

// Only a request that never got an answer is worth sending again; a timeout already waited its full
// length, and a real API error would come back the same.
export function isNoResponseError(error: any): boolean {
  return isConnectionError(error) && error?.name !== 'TimeoutError';
}
